import React from 'react';
import { Hero } from '../components/Hero';
import { SolutionSection } from '../components/SolutionSection';
import { ProductContents } from '../components/ProductContents';
import { BonusSection } from '../components/BonusSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { PricingSection } from '../components/PricingSection';
import { FinalCTA } from '../components/FinalCTA';
import { SocialProofPopup } from '../components/SocialProofPopup';
export function SalesPage() {
  return <div className="min-h-screen bg-navy-900 font-sans selection:bg-gold-500/30" data-id="element-219">
      <Hero data-id="element-220" />
      <SolutionSection data-id="element-221" />
      <ProductContents data-id="element-222" />
      <BonusSection data-id="element-223" />
      <PricingSection data-id="element-224" />
      <TestimonialsSection data-id="element-225" />
      <FinalCTA data-id="element-226" />
      <SocialProofPopup data-id="element-227" />
    </div>;
}